import { render } from "./orcamento.vue?vue&type=template&id=6b01b71a"
import script from "./orcamento.vue?vue&type=script&lang=js"
export * from "./orcamento.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__